import { createApp } from "vue";
import i18n from "@/common/helpers/i18n";
import Toast from "@/common/plugins/toast";
import App from "./App.vue";
import router from "./router";
import store from "./store";

// styles
import "@/styles/main.scss";
import "./twstyles/styles.css";

const app = createApp(App);

app.use(router);
app.use(store);
app.use(Toast);
app.use(i18n);

app.mount("#app");

app.config.errorHandler = (err, vm, info) => {
  console.error("Globlal vue file error captured:", err, info);
};
